(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-information"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') {
      var form = document.getElementById('tof-contact-form');
      var success = document.getElementById('ts-form-success');
      var section = document.getElementById('ts-contact');
      if (form) form.style.display = 'none';
      if (success) success.style.display = 'block';
      if (section) setTimeout(function() {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
